import { useParams } from 'react-router-dom';
import ZaehlerListeSeite from './liste/ZaehlerListeSeite';
import ZaehlerSeite from './detail/ZaehlerSeite';

/** Bereich „Zähler“ im neuen Design (Handoff Zähler): Liste und eigene Detailseite (/admin/zaehler/:id). */
export default function ZaehlerBereich({ userProfile }: { userProfile?: { id?: string } | null }) {
  const { id } = useParams<{ id: string }>();
  if (id) return <ZaehlerSeite key={id} zaehlerId={id} userProfile={userProfile} />;
  return <ZaehlerListeSeite />;
}
